import * as Yup from 'yup'

export const passwordMatch = () =>
  Yup.string().matches(
    /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d$@$!#%&()*+,\-.:;<=>?`^[\]{}|~]{8,64}$/,
    'Password must be at least 8 characters, contain at least one number and at least one letter'
  )

export default { passwordMatch }
